/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IPaymentWindowScope extends angular.IScope {
        model: models.PaymentWindowModel
    }


    export class PaymentWindowController implements IController {
        constructor(
            $scope: IPaymentWindowScope,
            $routeParams: ng.route.IRouteParamsService,
            $window: ng.IWindowService,
            paymentService: services.PaymentService)
        {
            var processId = $routeParams["processId"];
            var paymentConfigId = $routeParams["paymentConfigId"];
        
            $scope.model = new models.PaymentWindowModel($window, paymentService, processId, paymentConfigId);
        }
    }
}

warsApp.registerController("PaymentWindowController", ["$scope", "$routeParams", "$window", "paymentService"]);